export const ErrorComponent = (msg: string) => (
  <div className="form-error">{msg}</div>
)
